import { ChatRuntimeProvider } from '@/components/chat/chat-runtime-provider';
import { ChatShell } from '@/components/chat/chat-shell';
import { createFileRoute, useParams } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/chat')({
  component: ChatRoute,
});

function ChatRoute() {
  const params = useParams({ strict: false }) as { threadId?: string };
  const urlThreadId = params.threadId ?? null;

  return (
    <ChatRuntimeProvider urlThreadId={urlThreadId}>
      <ChatShell />
    </ChatRuntimeProvider>
  );
}
